"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extendParkingCard = extendParkingCard;
exports.freezeParkingCard = freezeParkingCard;
exports.getParkingCardOrderDetail = getParkingCardOrderDetail;
exports.getParkingCardOrderList = getParkingCardOrderList;
exports.getShopCarOrderDetail = getShopCarOrderDetail;
exports.getShopCarOrderList = getShopCarOrderList;
exports.unfreezeParkingCard = unfreezeParkingCard;
exports.updateParkingCardPlateNo = updateParkingCardPlateNo;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 获取停车订单列表
 * @param {Object} params - 查询参数
 */
function getShopCarOrderList(params) {
  return (0, _request.default)({
    url: '/admin/order/parking-fee/list',
    method: 'GET',
    params: params
  });
}

/**
 * 获取停车订单详情
 * @param {string} orderNo - 订单编号
 */
function getShopCarOrderDetail(orderNo) {
  return (0, _request.default)({
    url: "/admin/order/parking-fee/detail/".concat(orderNo),
    method: 'GET'
  });
}

/**
 * 获取停车卡订单列表
 * @param {Object} params - 查询参数
 */
function getParkingCardOrderList(params) {
  return (0, _request.default)({
    url: '/admin/order/parking-card/list',
    method: 'GET',
    params: params
  });
}

/**
 * 获取停车卡订单详情
 * @param {string} orderNo - 订单编号
 */
function getParkingCardOrderDetail(orderNo) {
  return (0, _request.default)({
    url: "/admin/order/parking-card/detail/".concat(orderNo),
    method: 'GET'
  });
}

/**
 * 更新停车卡订单车牌号
 * @param {Object} data - 更新参数 { plateNo, orderNo, id }
 */
function updateParkingCardPlateNo(data) {
  return (0, _request.default)({
    url: '/admin/order/parking-card/update',
    method: 'POST',
    data: data
  });
}
function freezeParkingCard(data) {
  return (0, _request.default)({
    url: '/admin/order/parking-card/freeze',
    method: 'POST',
    data: data
  });
}
function extendParkingCard(data) {
  return (0, _request.default)({
    url: '/admin/order/parking-card/extend',
    method: 'POST',
    data: data
  });
}
function unfreezeParkingCard(data) {
  return (0, _request.default)({
    url: '/admin/order/parking-card/unfreeze',
    method: 'POST',
    data: data
  });
}